import { Alert, LinearProgress } from '@mui/joy';

import { useParams, useSearchParams } from 'react-router-dom';

import Breadcrumbs from '@/components/Breadcrumbs';
import { useGetFlattenedChildRunsForRuns } from '@/hooks/useGetFlattenedChildRunsForRuns';

import Header from '../../components/CodeHeader';
import { useRun } from '../../hooks/useSwr';
import { FlatRun } from '../Run/utils/utils';
import { RunsPlayground } from './RunsPlayground';

export function PlaygroundPage() {
  const { runId } = useParams();
  const [searchParams] = useSearchParams();

  const run = useRun({
    id: runId,
    withContents: true,
    options: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  });

  const history = searchParams.get('history')?.split(',');

  // Arbitrary max of 10 runs
  const fetchedIds =
    history !== undefined ? [...(history?.slice(-9) ?? []), runId] : undefined;
  const {
    isLoading: historyRunsIsLoading,
    error: historyRunsError,
    flatRuns,
  } = useGetFlattenedChildRunsForRuns({
    runIds: fetchedIds?.filter(Boolean) as string[] | undefined,
  });

  const isLoading = historyRunsIsLoading || run.isLoading;
  const error = historyRunsError || run.error;

  const flatHistoryRuns: FlatRun[] | undefined = flatRuns;

  return (
    <div className="flex h-screen flex-col">
      <div className="px-4 pt-3">
        <Breadcrumbs />

        {isLoading && <LinearProgress />}

        {error && !isLoading && (
          <>
            <Header text="Error" copy={error?.message} />
            <Alert color="danger" variant="outlined" sx={{ marginBottom: 3 }}>
              {error?.message}
            </Alert>
          </>
        )}
      </div>

      {run.data && !isLoading && (
        <RunsPlayground run={run.data} history={flatHistoryRuns} />
      )}
    </div>
  );
}
